import { createContext } from 'react';

export const NoteContext = createContext(null);
